// core
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'open-price',
  templateUrl: './open-price.component.html',
  styleUrls: ['./open-price.component.scss']
})
export class OpenPriceComponent implements OnInit {
  @Input() price: any;
  @Input() precision?: number;
  @Input() size?: any;
  @Input() smallerDecimal: boolean = false;
  format: string = '2-2';
  symbol!: string;
  primarySize: string = 'display-small';
  secondarySize: string = 'display-xsmall';
  decimalSize: string = this.primarySize;

  constructor() { }

  ngOnInit(): void {
    if (this.precision === 0) {
      this.format = '0-0';
    }

    /*
    For text sizing we use primary and secondary sizes. These are used to have some text larger than others.
    This is all set through configuration.
    You can set the size to be a single value, or two values separated by a pipe (|).
    If you set a single value, it will be used for both primary and secondary sizes.
    If you set two values, the first value will be used for the primary size and the second value will be used for the secondary size.
    If no size is set, it will default to 'display-small' for primary and 'display-xsmall' for secondary.
    For existing/legacy implementations, one value was used for both sizes, so we need to handle that case too.
    */

    // One value provided
    if (this.size?.length > 0 && this.size?.split('|').length === 1) {
      this.primarySize = this.size;
      this.secondarySize = this.size;
    // Two values provided
    } else if (this.size?.split('|').length === 2) {
      this.primarySize = this.size.split('|')[0];
      this.secondarySize = this.size.split('|')[1];
    }

    this.decimalSize = this.smallerDecimal ? this.secondarySize : this.primarySize;
  }
}
